
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { API_ENDPOINTS, SERVER } from 'constants';

const TalkingAssistantAnimation = ({ isReading, width, height, avatar, style }) => {
    const { t } = useTranslation();
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleVideoPlay = async () => {
            try {
                await video.play();
            } catch (error) {
                console.error("Error attempting to play the video:", error.message);
            }
        };

        if (isReading) {
            handleVideoPlay();
        }

        const handleVideoEnd = () => {
            if (isReading) handleVideoPlay();
        };

        video.addEventListener('ended', handleVideoEnd);
        return () => video.removeEventListener('ended', handleVideoEnd);
    }, [isReading, avatar]);

    return (
        <video
            ref={videoRef}
            className="max-media-width avatar"
            width={width}
            height={height}
            controls={false}
            playsInline
            muted
            autoPlay={isReading}
            style={style}
        >
            <source src={`${SERVER}${API_ENDPOINTS.AVATARS.IMAGE_FOLDER}${avatar?.video_url}`} type="video/mp4" />
            {t('error.noVideoSupport')}
        </video>
    );
};

export default TalkingAssistantAnimation;
